import { formConfig } from 'molecules/Form/config';

import type { Input } from '@builder.io/sdk';

const agentQuoteFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'subheading',
        type: 'string',
      },
    ],
  },
  {
    name: 'formCoverages',
    type: 'object',
    subFields: [
      {
        name: 'title',
        type: 'string',
      },
      {
        name: 'options',
        type: 'list',
        subFields: [
          {
            name: 'label',
            type: 'string',
          },
          {
            name: 'value',
            type: 'string',
          },
        ],
      },
    ],
  },
  {
    name: 'disclaimer',
    type: 'string',
  },
  {
    name: 'information',
    type: 'object',
    subFields: [
      {
        name: 'heading',
        type: 'string',
      },
      {
        name: 'blocks',
        type: 'list',
        subFields: [
          {
            name: 'leftSide',
            type: 'object',
            subFields: formConfig.inputs,
          },
          {
            name: 'rightSide',
            type: 'object',
            subFields: formConfig.inputs,
          },
          {
            name: 'addDivider',
            type: 'boolean',
            defaultValue: false,
          },
        ],
      },
    ],
  },
  {
    name: 'threeInfo',
    type: 'object',
    subFields: [
      {
        name: 'field1',
        type: 'object',
        subFields: formConfig.inputs,
      },
      {
        name: 'field2',
        type: 'object',
        subFields: formConfig.inputs,
      },
      {
        name: 'field3',
        type: 'object',
        subFields: formConfig.inputs,
      },
      {
        name: 'addDivider',
        type: 'boolean',
        defaultValue: false,
      },
    ],
  },
  {
    name: 'contacts',
    type: 'richText',
  },
  {
    name: 'redirect_url',
    type: 'object',
    subFields: [
      {
        name: 'dev_url',
        friendlyName: 'dev',
        type: 'string',
      },
      {
        name: 'qa_url',
        friendlyName: 'qa',
        type: 'string',
      },
      {
        name: 'staging_url',
        friendlyName: 'uat',
        type: 'url',
      },
      {
        name: 'production_url',
        friendlyName: 'prod',
        type: 'url',
      },
    ],
  },
] as const satisfies DeepReadonly<Input[]>;

const agentQuoteConfig = {
  name: 'Agent Quote',
  inputs: agentQuoteFields,
};

export type AgentQuoteProps = GenerateBuilder<typeof agentQuoteFields>;

export default agentQuoteConfig;
